import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Header from "./Header";
import Home from "./Home";
import Checkout from "./Checkout";
import Login from "./Login";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import { auth } from "./firebase";
import { useStateValue } from "./StateProvider";
import Payment from "./Payment";
import Orders from "./Orders";
const promise = loadStripe('pk_test_51RrjDYRSH4bOjFZ3LnSx4mOnsStFMvj2iqsUUvtjf5KEko7tnxVSOs8kQp5JwNG0tMmqwCndN66j5x6ch9HSj4VA0028GYRXqp');

function App() {
  const [{}, dispatch] = useStateValue();

  useEffect(() => {
    //will only run once when the app component loads...

    auth.onAuthStateChanged(authUser => {
      console.log('THE USER IS >>> ', authUser);

      if (authUser) {
        // the user just logged in / the user was logged in

        dispatch({
          type: 'SET_USER',
          user: authUser
        })
      } else {
        // the user id logged out
        dispatch({
          type: 'SET_USER',
          user: null
        })
      }
    })
  }, [])

  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/orders" element={<><Header /><Orders/></>}/>
          <Route path="/checkout" element={<><Header /><Checkout /></>} />
          <Route path="/login" element={<Login/>}/>
          {/* This is the main page */}
          <Route path="/" element={<><Header /><Home/></>} />
          <Route path="/payment" element={<><Header /><Elements stripe={promise}><Payment /></Elements></>} />
        </Routes>
      </div>
    </Router>
  );
}

{/* We NEED React-ROUTER */}
{/* localhost.com */}
{/* localhost.com/checkout */}
{/* localhost.com/login */}

export default App;